export default {"src":"/_next/static/media/dollar-fill.d2a28bfa.svg","height":36,"width":36};